<template>
    <div class="group-inner-page-main-sect">
      <v-container class="go-back-btn-section the-main-concept">
        <v-layout>
          <div class="go-back-btn-sect group-page">
            <v-btn @click="openGroupPage"
                   color="transparent"
                   class="go-back-btn"
                   :ripple="false"
                   to="/profile/my-groups"
            >
              <v-icon>icon-arrow-347</v-icon>
              <span>{{$t('group.back_to_group_list')}}</span>
            </v-btn>
          </div>
        </v-layout>
      </v-container>
      <v-container class="group-members-section the-main-concept">
        <v-container text-xs-center v-if="group && group.displayData" class="group-info-sect">
          <div class="group-name-title">
            <span>{{group.displayData.name}}</span>
          </div>
          <div class="group-description-title">
            <span>{{group.displayData.description}}</span>
          </div>
          <v-layout row class="avatar-img-info-and-btn-sect" justify-space-between>
            <div class="creator-info-sect">
              <v-list-tile-avatar v-if="group.Creator">
                <router-link v-if="group.Creator.image" :to="/accounts/ + group.userId">
                  <img :src="`${ROOT_API}${group.Creator.image}`" :alt="$t('avatar')">
                </router-link>
                <i v-else class="material-icons">
                  account_circle
                </i>
              </v-list-tile-avatar>
              <div class="creator-personal-info">
                <router-link :to="/accounts/ + group.userId">
                  <span>
                    {{group.Creator.firstName + " " + group.Creator.lastName }}
                  </span>
                </router-link>
                <div>{{$t('group.creator')}}</div>
              </div>
            </div>
            <div class="search-field-btn-sect">
              <div class="row">
                <div class="col">
                  <v-text-field
                    v-model="search"
                    append-icon="icon-magnifying-glass"
                    :placeholder="$t('products.search')"
                    single-line
                    hide-details
                    class="search-field member-search group-member-search"
                    flat solo
                  /></div>
                <div class="col">
                  <v-alert v-if="searchGroupMemeberData.length === 0 && group.memberData.length" :value="true"  type="error">
                    <div class="info-icon">
                      {{$t('settings.no_result_for_search')}}
                    </div>
                  </v-alert>
                </div>
              </div>
              <v-btn v-if="loggedUser.id === group.userId" @click="openAddMemberModal" :ripple="false" class="add-member-to-group">
                {{$t('group.add_member')}}
                <v-icon>icon-plus-big</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-container>
      <v-container  text-xs-center class="group-member-count-container">

        <v-layout>
          <v-flex v-if="group && group.memberData">
            <v-layout row wrap v-if="group.memberData.length > 0" class="group-have-members-sect">
              <v-flex d-flex ex-friend-item xs12 sm4 md4 lg3 v-for = "(user,index) in searchGroupMemeberData"  :key="index">
                <v-list-tile-avatar class="avatar-image">
                  <img v-if="user.User.image" :src="`${ROOT_API}${user.User.image}`" :alt="$t('avatar')" />
                  <img v-else src="../../../src/assets/images/NoImage.png" :alt="$t('avatar')" />
                </v-list-tile-avatar>
                <v-list-tile-content  class="friend-info-content">
                  <router-link :to="`/accounts/${user.User.id}`">
                    <v-list-tile-title class="name-info" v-html="user.User.firstName + ' ' + (user.User.lastName || '')"></v-list-tile-title>
                  </router-link>
                  <v-flex class="d-flex flex-row product-status">
                    <p class="m25-0 ex-info-text">{{$t('received') + ':'}}<span class="ml-2">{{user.receivedProductsCount}}</span></p>
                    <p class="m25-0 ex-info-text ml-2">{{$t('given') + ':'}}<span class="ml-2">{{user.givenProductsCount}}</span></p>
                  </v-flex>
                </v-list-tile-content>
                <v-list-tile-action class="dropdown-btn-sect">
                  <v-menu
                          nudge-bottom="5"
                          nudge-left="155"
                          content-class="dropdown-menu"
                          transition="slide-y-transition"
                          class="dropdown-menu-sect"
                  >
                    <v-btn class="dropdown-btn" flat solo :ripple="false" slot="activator">
                      <v-icon>icon-more-hover</v-icon>
                    </v-btn>
                    <v-card class="dropdown-card">
                      <v-list dense class="btn-list">
                        <div class="btn-list-item" v-if="loggedUser.id !== user.User.id">
                          <v-list-tile flat solo :ripple="false" class="message-send-btn">
                            <v-icon>icon-message</v-icon>
                            Send message
                          </v-list-tile>
                        </div>
                        <div class="btn-list-item">
                          <v-list-tile v-if="loggedUser.id === group.userId || loggedUser.id === user.User.id" @click="deleteMemberModal(user.User.id, user.GroupRequests.id)" flat solo :ripple="false"
                                       class="delete-friend-btn">
                            <v-icon>icon-remove-565</v-icon>
                            Delete
                          </v-list-tile>
                        </div>
                      </v-list>
                    </v-card>
                  </v-menu>
                </v-list-tile-action>
              </v-flex>
            </v-layout>
            <v-layout  v-else class="group-dont-have-member">
              <v-flex>
                <div class="not-received">
                  <img class="emptyImg" src="../../assets/images/empty.svg" alt="" />
                  <p>{{$t('group.list_empty')}}</p>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <!--Add Member Modal-->
      <v-dialog class="ex-dialog" v-model="openMemberModal" persistent max-width="500px">
        <v-card-title
            class="justify-center ex-card-title select-group-person-condition-sect">
          <v-layout class="g-cancel-btn">
            <v-btn
                    :ripple="false"
                class="ex-v-btn ex-close-btn"
                @click.native="openMemberModal = false">
              <i class="icon-cancel"></i>
            </v-btn>
          </v-layout>
          <v-layout column class="justify-center group-modal-head-title">
            <h1 class="g-registration" >{{ $t('group.add_member') }}</h1>
            <v-flex xs6 md12 lg12 class="select-condition-btn-sect">
              <v-btn @click="getList('friends')" flat :class="this.selectedTab === 0 && 'friend-active'" :ripple="false" class="friends-chose-btn">{{$t('group.friends')}}</v-btn>
              <v-btn @click="getList('others')" flat :class="this.selectedTab === 1 && 'friend-active'" :ripple="false" class="other-users-chose-btn">{{$t('group.others')}}</v-btn>
            </v-flex>
          </v-layout>

        </v-card-title>
        <v-card class="ex-card-content group-member-chose">
          <v-alert v-if="showRequestAlert" :value="true" type="info">
          </v-alert>
          <v-card-text class="mt-3 ex-scroll" v-if="people.length > 0">
            <v-list-tile
                v-for="item in people"
                :key="item.id"
                avatar
                class="friend-request-member-sect"
            >
              <v-list-tile-avatar v-if="item.Friend.image" class="members-avatar-img">
                <img :src="`${ROOT_API}${item.Friend.image}`" :alt="$t('avatar')">
              </v-list-tile-avatar>
              <v-list-tile-avatar v-else class="members-avatar-img">
                <img src="../../assets/images/NoImage.png" :alt="$t('avatar')">
              </v-list-tile-avatar>

              <v-list-tile-content class="members-name">
                <v-list-tile-title v-html="item.Friend.firstName + ' ' + item.Friend.lastName"></v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action class="members-action-sect">
                <div v-if="item.groupReq.length === 0 || (item.groupReq.length > 0 && item.groupReq[0].accepted === false)" class="invite-version-sect">
                  <v-btn @click="openGroupRequestModal(item.Friend.id)" flat :ripple="false" class="group-invite-btn">{{$t('group.invite')}}</v-btn>
                </div>
                <div  v-else-if="item.groupReq.length > 0 && item.groupReq[0].accepted === null"  class="accepted-invited-cancel-version-sect">
                  <span>{{$t('group.invited')}}</span>
                  <v-btn :ripple="false" flat @click="cancelGroupRequestModal(item.groupReq[0].id)" class="group-cancel-btn">{{$t('group.cancel')}}</v-btn>
                </div>
                <div  v-else-if="item.groupReq.length > 0 && item.groupReq[0].accepted === true" class="accepted-invited-cancel-version-sect">
                  <span>{{$t('group.accepted')}}</span>
                  <v-btn :ripple="false" @click="deleteMemberModal(item.Friend.UserGroups[0].userId, item.groupReq[0].id)" flat class="group-cancel-btn">{{$t('group.cancel')}}</v-btn>
                </div>
              </v-list-tile-action>
            </v-list-tile>
          </v-card-text>
          <v-card-text class="mt-3 friends-not-found" v-else>
            <img class="emptyImg" src="../../assets/images/empty.svg" alt=""  >
            <span>{{$t('group.you_dont_have_friends')}}</span>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" max-width="550px">
        <v-form ref="form" v-model="valid" lazy-validation class="disable-form-contact">
          <v-card color="grey lighten-4">
            <v-card-title class="cancel-btn-card-sect">
              <v-btn class="cancel-request-btn1" :ripple="false" @click.native="closeModal">
                <v-icon>icon-cancel</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-title class="text-md-center card-first-sect">
              <span class="modal-headline">{{$t('group.send_request_message')}}</span>
            </v-card-title>
            <v-card-text class="p-0-14">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex>
                    <v-textarea
                        v-model="requestMessage"
                        :rules="requestMessageRules"
                        :counter="250"
                        name="requestMessage"
                        outline
                        class="modal-text-field ex-input-group"
                        :no-resize="true"
                    >
                    </v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions  class="modal-btn-sect">
              <v-btn flat class="cancel-request-btn2" :ripple="false" @click.native="closeModal">{{$t('group.cancel')}}</v-btn>
              <v-btn flat class="send-request-btn"  :ripple="false" @click.native="sendRequestMessage">{{$t('group.send')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!--Cancel Modal-->
      <v-dialog v-model="cancelModal" max-width="550px" >
        <v-card class="delete-friend-modal">
          <v-card-title  class="headline-title">
            <span>{{$t('group.cancel_group_req')}}</span>
          </v-card-title>
          <v-card-text class="delete-modal-text">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex>
                  <span>{{$t('group.cancel_group_req_text')}}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="delete-friend-btn-sect">
            <v-btn flat :ripple="false" class="cancel-delete-btn" @click.native="closeModal">{{$t('group.no')}}</v-btn>
            <v-btn flat :ripple="false" class="accept-delete-btn" @click.native="cancelGroupRequest">{{$t('group.yes')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--group member delete modal-->
      <v-dialog v-model="deleteGroupMember" max-width="550px" persistent>
        <v-card class="delete-friend-modal">
          <v-card-title class="headline-title">
            <span>{{$t('group.delete_group_member')}}</span>
          </v-card-title>
          <v-card-text class="delete-modal-text">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex>
                  <span>{{$t('group.delete_group_member_text')}}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="delete-friend-btn-sect">
            <v-btn  flat :ripple="false" class="cancel-delete-btn" @click.native="closeModal">{{$t('group.cancel')}}</v-btn>
            <v-btn flat :ripple="false" class="accept-delete-btn" @click.native="deleteMember">{{$t('group.delete')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-container>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import SearchIndividualComponents from '../profilePage/components/SearchIndividualUsers'
import { EventBus } from '../../event-bus'

export default {
  name: 'currentGroup',
  components: {
    SearchIndividualComponents
  },
  data: () => ({
    search: '',
    deleteGroupMember: false,
    deleteGroupMemberId: '',
    reqGroupMemberId: '',
    selectedTab: 0,
    groupRequestId: '',
    cancelModal: false,
    userId: '',
    valid: true,
    requestMessage: '',
    ROOT_API: process.env.ROOT_API,
    openMemberModal: false,
    showRequestAlert: false,
    people: [],
    friends: [],
    noFriends: [],
    invite: true,
    dialog: false
  }),
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData,
      group: state => state.groups.currentGroup,
      accountInfo: state => state.accounts.accountInfo
    }),
    searchGroupMemeberData: function () {
      let membersData = this.group.memberData
      let filtered = membersData
      if (this.search) {
        filtered = membersData.filter(
          member => member.User.firstName.toLowerCase().indexOf(this.search) > -1
        )
      }
      return filtered
    },
    requestMessageRules () {
      return [
        v => (!!v && v.trim() !== '') || this.$t('group.request_message_required'),
        v => v.length <= 80 || this.$t('group.group_desc_valid')
      ]
    }
  },
  watch: {
    noFriends: function (val) {
      this.people = val
    },
    friends: function (val) {
      this.people = val
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    newNotification: function () {
      this.getGroups()
      if (this.selectedTab === 0) {
        this.getNoFriendsData()
        this.getFriendsData()
      }
      if (this.selectedTab === 1) {
        this.getFriendsData()
        this.getNoFriendsData()
      }
    }
  },
  methods: {
    getGroups () {
      if (!this.$route.params.groupId) {
        this.$router.push('/profile/my-groups')
      }
      this.$store.dispatch('groups/getGroupById', {groupId: this.$route.params.groupId})
        .then(response => {
        }).catch(err => {
          console.log(err)
        })
    },
    getFriendsData () {
      this.$store.dispatch('profile/getUserFriends', {groupId: this.$route.params.groupId})
        .then(response => {
          let friendsData = []
          this.getGroups()
          if (response.friends.length > 0) {
            response.friends.forEach(friend => {
              friend.groupReq = []
              friend.Friend.GroupRequests.forEach(groupReq => {
                if (groupReq.groupId === +this.$route.params.groupId) {
                  friend.groupReq.push(groupReq)
                }
              })
              friendsData.push(friend)
            })
          }
          this.friends = friendsData
        }).catch(err => {
          console.log(err)
        })
    },
    getNoFriendsData () {
      this.$store.dispatch('profile/getNoFriends', {groupId: this.$route.params.groupId})
        .then(response => {
          let noFriendsData = []
          response.noFriends.forEach(user => {
            user.Friend = user
            user.groupReq = []
            user.GroupRequests.forEach(groupReq => {
              if (groupReq.groupId === +this.$route.params.groupId) {
                user.groupReq.push(groupReq)
              }
            })
            noFriendsData.push(user)
          })
          this.noFriends = noFriendsData
        }).catch(err => {
          console.log(err)
        })
    },
    closeModal () {
      this.dialog = false
      this.cancelModal = false
      this.deleteGroupMember = false
      this.requestMessage = ''
    },
    languageChanged () {
      this.getGroups()
    },
    openGroupPage () {
      this.$router.push('/profile/my-groups')
    },
    openAddMemberModal () {
      this.selectedTab = 0
      this.openMemberModal = true
      this.people = this.friends
    },
    getList (list) {
      if (list === 'friends') {
        this.selectedTab = 0
        this.people = this.friends
      } else if (list === 'others') {
        this.people = this.noFriends
        this.selectedTab = 1
      }
    },
    cancelGroupRequestModal (id) {
      this.groupRequestId = id
      this.cancelModal = true
    },
    cancelGroupRequest () {
      this.$store.dispatch('groups/deleteGroupReq', this.groupRequestId).then((res) => {
        if (res.status) {
          if (this.selectedTab === 0) {
            this.getFriendsData()
          }
          if (this.selectedTab === 1) {
            this.getNoFriendsData()
          }
          this.closeModal()
          this.$toastr(res.type, res.message, this.$t(res.type))
        }
      }).catch(console.error)
    },
    sendRequestMessage () {
      if (this.$refs.form.validate()) {
        let request = {
          message: this.requestMessage,
          groupId: this.group.id,
          fromUserId: this.group.userId,
          userId: this.userId
        }
        this.$store.dispatch('groups/sendGroupRequest', request).then((res) => {
          if (res.groupRequest) {
            this.requestMessage = ''
            if (this.selectedTab === 0) {
              this.getFriendsData()
            }
            if (this.selectedTab === 1) {
              this.getNoFriendsData()
            }
            this.closeModal()
            this.$toastr(res.type, res.message, this.$t(res.type))
            this.$store.dispatch('accounts/clearAccountInfo', {})
          }
        }).catch(console.error)
      }
    },
    openGroupRequestModal (id) {
      this.userId = id
      this.dialog = !this.dialog
      if (this.selectedTab === 0) {
        this.getFriendsData()
      }
      if (this.selectedTab === 1) {
        this.getNoFriendsData()
      }
    },
    deleteMember () {
      if (this.deleteGroupMemberId) {
        if (this.deleteGroupMemberId === this.loggedUser.id || this.loggedUser.id === this.group.userId) {
          this.deleteGroupMember = false
          this.$store.dispatch('groups/deleteGroupMember', {memberId: this.deleteGroupMemberId, groupId: this.group.id}).then((res) => {
            if (res.status) {
              this.getGroups()
              if (this.selectedTab === 0) {
                this.getFriendsData()
              }
              if (this.selectedTab === 1) {
                this.getNoFriendsData()
              }
              this.$toastr(res.type, res.message, this.$t(res.type))
            }
          }).catch(console.error)
          this.$store.dispatch('groups/deleteGroupReq', this.reqGroupMemberId).then((res) => {
            if (res.status) {
              if (this.selectedTab === 0) {
                this.getFriendsData()
              }
              if (this.selectedTab === 1) {
                this.getNoFriendsData()
              }
              this.closeModal()
            }
          }).catch(console.error)
        } else {
          this.$toastr('error', this.$t('group.permission'), this.$t('error'))
        }
      } else {
        this.$toastr('error', this.$t('group.permission'), this.$t('error'))
      }
    },
    deleteMemberModal (id, reqId) {
      this.deleteGroupMember = true
      this.deleteGroupMemberId = id
      this.reqGroupMemberId = reqId
    }
  },
  created () {
    if (this.accountInfo && this.accountInfo.user && this.group) {
      setTimeout(() => {
        let openModal = true
        if (this.group.GroupRequests && this.group.GroupRequests.length > 0) {
          this.group.GroupRequests.forEach((request, i) => {
            if (request.userId === this.accountInfo.user.id) {
              openModal = false
            }
          })
        }
        if (openModal) {
          this.openGroupRequestModal(this.accountInfo.user.id)
        }
      }, 1000)
    }
    EventBus.$on('language-changed', this.languageChanged)
    this.getGroups()
    this.getNoFriendsData()
    this.getFriendsData()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/desktop/groupInnerPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/currentGroup.vue